export default {
  textfield: {
    width: '100%',
    height: '100%',
    fontSize: '0.875rem',

    '& .MuiSelect-nativeInput': {
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '10px 12px',
      fontSize: '0.875rem',
      color: (theme) => theme.palette.grays.gray600,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: `none`,
    },

    '& .MuiInputBase-root': {
      backgroundColor: (theme) => theme.palette.blues.lightestBlue,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.blues.lightestBlue,

        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 0,
          border: 'none',
        },
      },
    },
  },
};
